import { AssistantOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import Button from '@/components/Buttons/Button';
import { Tag } from '@/components/Tag';

const AskGXButton = ({
  onClick
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <Button
      color='primary'
      size='large'
      startIcon={<AssistantOutlined />}
      sx={{
        whiteSpace: 'nowrap',
        minWidth: 250
      }}
      variant='contained'
      onClick={onClick}
    >
      GX Go Assistant
      <Box
        sx={{
          ml: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Tag />
      </Box>
    </Button>
  );
};

export default AskGXButton;
